export default __webpack_public_path__ + "static/media/icon-length.1178dfee.svg";